import React, { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import './style.css';

const InstallChatWidget = () => {

  const userData = useSelector((state) => state.loginToken);

  const styles = {
    codeContainer: {
      display: 'flex',
      fontFamily: 'monospace',
      padding: '10px',
      fontSize: '14px'
    },
    lineNumbers: {
      paddingRight: '10px',
      textAlign: 'right',
      color: '#148DFD',
      userSelect: 'none',
    },
    codeContent: {
      whiteSpace: 'pre',
    },
    lineNumber: {
      lineHeight: '1.5',
    },
    codeLine: {
      lineHeight: '1.5',
    },
  };

  const code = `<script>
  (function () {
    var script = document.createElement("script");
    script.src = "https://trustchatwidget.netlify.app/chat-widget.js";
    script.onload = function () {
      ChatWidget({
        businessId: '${userData?.response?.user?.business_id}', 
      });
    };
    document.head.appendChild(script);
  })();
</script>
    `;

  const codeLines = code.split('\n');

  return (

    <div>

      <p className="parInfoStart">Install chat widget</p>
      <p className="settingsInfoTextTop">To see TrustChat on your website, you’ll need to add a bit of code or configure an integration.</p>

      <div className='installChat'>
        <div className='installChatBox'>
          <p className="parInfo">Install chat widget manually</p>
          <p className="installInfoText">Copy and paste the code before the <span style={{ fontWeight: '500', color: '#148DFD' }}>{'</body>'}</span> tag on every page of your website.</p>
          <p className="Install-Line-Bottom" />

          <div className="codeContainer">
            <div className="lineNumbers">
              {codeLines.map((_, index) => (
                <div key={index} className="lineNumber">{index + 1}</div>
              ))}
            </div>
            <div className="codeContent">
              {codeLines.map((line, index) => (
                <div key={index} className="codeLine">{line}</div>
              ))}
            </div>
          </div>
          <div class="gradientback">
          </div>

        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '16px 0 32px 0' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button className=" invite-dev-button" type="button" >+ Invite your developer</button>
            <button className=" installation-guide-button" type="button" >Check install Guide</button>
          </div>
          <div>
            <button className="settings-tab-button copy-code-button" type="button" onClick={() => navigator.clipboard.writeText(code)}>Copy Code</button>
          </div>
        </div>



      </div>

    </div>
  )

}

export default InstallChatWidget;
